import * as React from "react";
import { APINames } from "../../../../legacy/api/api.names";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";

import {
  KeypadButtonMinimal,
  SpinControlKeypadButtonMinimal,
  StyledAutoplayButtonMinimal
} from "./components/Buttons";
import { SoundButtonMinimal } from "./components/SoundButton/SoundButton.Minimal.container";
import { MinimalContainer } from "./components/Wrappers.Minimal";
import { IKeypadDesktop } from "./KeypadDesktop";

import { BalanceDisplayDesktopMinimal } from "../../../../v2/components/Display/desktop/Balance";
import { BetDisplayDesktopMinimal } from "../../../../v2/components/Display/desktop/Bet";
import { FreeRoundsDisplayDesktopMinimal } from "../../../../v2/components/Display/desktop/FreeRounds";
import { TotalWinDisplayDesktopMinimal } from "../../../../v2/components/Display/desktop/TotalWin";
import { WinDisplayDesktopMinimal } from "../../../../v2/components/Display/desktop/Win";
import { FreeSpinsDisplayDesktopMinimal } from "../../../../v2/components/Display/desktop/FreeSpins";
import { View } from "../../../../api/api";

export const KeypadDesktopMinimalView = ({
  hidden,
  autoplayAvailable,
  autoplayRoundsLeft,
  autoplayRunning,
  isFreeRoundsEnabled,
  isFreeSpinsEnabled,
  menuButtonDisabled,
  quickSpinEnabled,
  quickSpinAvailable,
  quickSpinActive,

  triggerDefaultViewChangeRequest,
  triggerGameRulesViewChangeRequest,
  triggerQuickSpinChangeRequest,

  view
}: IKeypadDesktop) => {
  const isSettingsMenuViewActive =
    view === View.MAIN_SETTINGS ||
    view === View.GAME_RULES ||
    view === View.GAME_HISTORY;
  const showAutoplayButton = autoplayRunning && autoplayAvailable;

  const MenuButton = (
    <KeypadButtonMinimal
      apiName={APINames.MENU_BUTTON}
      type="menu"
      onClick={
        !menuButtonDisabled &&
        (isSettingsMenuViewActive
          ? triggerDefaultViewChangeRequest
          : triggerGameRulesViewChangeRequest)
      }
      disabled={menuButtonDisabled}
    />
  );

  const AutoplayButton = (
    <StyledAutoplayButtonMinimal
      data-e2e-id={E2EIdentifier.MINIMAL_KEYPAD_AUTOPLAY_BUTTON}
      autoplayRunning={autoplayRunning}
      autoplayRoundsLeft={autoplayRoundsLeft}
      useSmallIcon={true}
    />
  );

  const QuickSpinButton = (
    <SpinControlKeypadButtonMinimal
      apiName={APINames.QUICKSPIN_BUTTON}
      data-e2e-id={E2EIdentifier.MINIMAL_KEYPAD_QUICK_SPIN_BUTTON}
      type="quickspin"
      onClick={
        quickSpinEnabled && triggerQuickSpinChangeRequest(!quickSpinActive)
      }
      disabled={!quickSpinEnabled}
      active={quickSpinActive}
    />
  );

  return (
    <MinimalContainer hidden={hidden}>
      <section>
        <div>{MenuButton}</div>
        <div>{showAutoplayButton && AutoplayButton}</div>
      </section>

      <section>
        {isFreeSpinsEnabled && (
          <div>
            <FreeSpinsDisplayDesktopMinimal />
          </div>
        )}

        <div>
          <WinDisplayDesktopMinimal />
        </div>

        <div>
          <BetDisplayDesktopMinimal />
        </div>

        <div>
          {isFreeRoundsEnabled ? (
            <TotalWinDisplayDesktopMinimal />
          ) : (
            <BalanceDisplayDesktopMinimal />
          )}
        </div>

        {isFreeRoundsEnabled && (
          <div>
            <FreeRoundsDisplayDesktopMinimal />
          </div>
        )}
      </section>

      <section>
        <div>{quickSpinAvailable && QuickSpinButton}</div>
        <div>{<SoundButtonMinimal />}</div>
      </section>
    </MinimalContainer>
  );
};
